export default __webpack_public_path__ + "static/media/logo31.6367b0a6.png";